import { Injectable } from '@angular/core';
import { RestConnector } from './rest.connector';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiHelperService {
    constructor(private restConnector: RestConnector) {}

    getAll(path: string, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        return this.restConnector.get(path, params, headers, responseType, hostnameOption);
    }

    getByUrl(url: string, params?: any, headers?: Record<string, string>, responseType?: any): Observable<any> {
        return this.restConnector.getByUrl(url, params, headers, responseType);
    }

    getById(path: string, id: string, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        path = path.toString().replace(':id', id);
        return this.restConnector.get(path, params, headers, responseType, hostnameOption);
    }

    getChildren(path: string, keyMap: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        const keys = Object.keys(keyMap);
        for (const key of keys) {
            if (path.toString().includes(':' + key)) {
                path = path.toString().replace(':' + key, keyMap[key]);
            }
        }
        return this.restConnector.get(path, params, headers, responseType, hostnameOption);
    }

    create(path: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        return this.restConnector.post(path, body, params, headers, responseType, hostnameOption);
    }

    createByUrl(url: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any): Observable<any> {
        return this.restConnector.postByUrl(url, body, params, headers, responseType);
    }

    createById(path: string, id: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        path = path.toString().replace(':id', id);
        return this.restConnector.post(path, body, params, headers, responseType, hostnameOption);
    }

    createChildren(path: string, keyMap: any, body?: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        const keys = Object.keys(keyMap);
        for (const key of keys) {
            if (path.toString().includes(':' + key)) {
                path = path.toString().replace(':' + key, keyMap[key]);
            }
        }
        return this.restConnector.post(path, body, params, headers, responseType, hostnameOption);
    }

    update(path: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        return this.restConnector.put(path, body, params, headers, responseType, hostnameOption);
    }

    updateByUrl(url: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any): Observable<any> {
        return this.restConnector.putByUrl(url, body, params, headers, responseType);
    }

    updateById(path: string, id: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        path = path.toString().replace(':id', id);
        return this.restConnector.put(path, body, params, headers, responseType, hostnameOption);
    }

    updateChildren(path: string, keyMap: any, body?: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        const keys = Object.keys(keyMap);
        for (const key of keys) {
            if (path.toString().includes(':' + key)) {
                path = path.toString().replace(':' + key, keyMap[key]);
            }
        }
        return this.restConnector.put(path, body, params, headers, responseType, hostnameOption);
    }

    patch(path: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        return this.restConnector.patch(path, body, params, headers, responseType, hostnameOption);
    }

    patchByUrl(url: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any): Observable<any> {
        return this.restConnector.patchByUrl(url, body, params, headers, responseType);
    }

    patchById(path: string, id: string, body?: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        path = path.toString().replace(':id', id);
        return this.restConnector.patch(path, body, params, headers, responseType, hostnameOption);
    }

    delete(path: string, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        return this.restConnector.delete(path, params, headers, responseType, hostnameOption);
    }

    deleteByUrl(url: string, params?: any, headers?: Record<string, string>, responseType?: any): Observable<any> {
        return this.restConnector.deleteByUrl(url, params, headers, responseType);
    }

    deleteById(path: string, id: string, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        path = path.toString().replace(':id', id);
        return this.restConnector.delete(path, params, headers, responseType, hostnameOption);
    }

    deleteChildren(path: string, keyMap: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        const keys = Object.keys(keyMap);
        for (const key of keys) {
            if (path.toString().includes(':' + key)) {
                path = path.toString().replace(':' + key, keyMap[key]);
            }
        }
        return this.restConnector.delete(path, params, headers, responseType, hostnameOption);
    }

    deleteWithBody(path: string, body: any, params?: any, headers?: Record<string, string>, responseType?: any, hostnameOption = ''): Observable<any> {
        return this.restConnector.deleteWithBody(path, body, params, headers, responseType, hostnameOption);
    }

    postFormData(path: string, formData: FormData, params?: any, responseType?: any, hostnameOption = ''): Observable<any> {
        return this.restConnector.postFormData(path, formData, params, responseType, hostnameOption);
    }

    exportFile(path: string, body: any, responseType?: any, headers?: Record<string, string>, hostnameOption = ''): Observable<any> {
        return this.restConnector.exportFile(path, body, responseType, headers, hostnameOption);
    }

    /** GET returning HttpResponse<Blob> for downloads that need headers (e.g. Content-Disposition). */
    getBlobResponse(path: string, params?: any, headers?: Record<string, string>, hostnameOption = ''): Observable<any> {
        return this.restConnector.getBlobResponse(path, params, headers, hostnameOption);
    }
}
